import { BiLeaf } from 'react-icons/bi';
import FeedbackFlagWrapper from 'components/FeedbackFlagWrapper';
import { FiChevronRight } from 'react-icons/fi';
import Stack from './Stack';
import Tooltip from 'components/Tooltip';
import styled from 'styled-components';
import { v5 as uuidv5 } from 'uuid';

const FlavorFlagWrapper = styled(FeedbackFlagWrapper)`
    font-family: ${({ theme }) => theme.style_primary};
    text-transform: capitalize;
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
    font-weight: 500;
    border-radius: 100px;
    background-color: white;
    padding: 2px 0.375rem;
    border: 1px solid transparent;
    transition: border-color 0.3s ease-in-out;

    & > span {
        display: flex;
        margin-right: ${({ theme }) => theme.space_2}px;
    }

    &:hover {
        border-color: ${({ theme }) => theme.purple_4};
    }

    button {
        color: ${({ theme }) => theme.gray_4};
        opacity: 1;
        &:focus-visible {
            opacity: 1;
            color: ${({ theme }) => theme.purple_1};
        }
    }

    &:hover button {
        opacity: 1;
        color: ${({ theme }) => theme.purple_1};
    }
`;

const IconWrapper = styled.span`
    margin-right: ${({ theme }) => theme.space_2}px;
    color: ${({ theme }) => theme.gray_4};
    display: inline-flex;
    align-self: center;
`;

function FlavorBadgesList({ flavors, categoryId }) {
    if (!flavors || flavors.length === 0) return null;
    return (
        <Stack
            $direction="row"
            css={`
                margin-top: 0.5rem;
                padding: 2px 0 4px 0;
                gap: 10px;
            `}
        >
            {flavors.map(([id, { cat2, cat3, cat4 }]) => (
                <Tooltip
                    content={
                        <Stack
                            $space="4px"
                            $direction="row"
                            $wrap={false}
                            css={`
                                align-items: center;
                                text-transform: capitalize;
                                font-size: 14px;
                                color: white;
                                font-weight: 400;
                                font-family: ${({ theme }) =>
                                    theme.style_primary};
                            `}
                        >
                            <Stack
                                $direction="row"
                                $wrap={false}
                                css={`
                                    align-items: center;
                                `}
                            >
                                <IconWrapper>
                                    <BiLeaf
                                        style={{
                                            minWidth: '1.25em',
                                            height: '1.25em',
                                        }}
                                    />
                                </IconWrapper>
                                <span>{cat2}</span>
                            </Stack>
                            <FiChevronRight
                                style={{
                                    minWidth: '1.25em',
                                    height: '1.25em',
                                }}
                            />
                            <span>{cat3}</span>
                            <FiChevronRight
                                style={{
                                    minWidth: '1.25em',
                                    height: '1.25em',
                                }}
                            />
                            <span>{cat4}</span>
                        </Stack>
                    }
                    mixpanelMeta={{ contentKey: 'flavors' }}
                    width={'fit-content'}
                    showTimeout={300}
                >
                    <FlavorFlagWrapper
                        flagId={uuidv5(categoryId, id)}
                        flagData={{ categoryId, cat4, feedback: 'flavors' }}
                    >
                        <IconWrapper>
                            <BiLeaf
                                style={{
                                    minWidth: '1.25em',
                                    height: '1.25em',
                                }}
                            />
                        </IconWrapper>
                        <span>{cat4}</span>
                    </FlavorFlagWrapper>
                </Tooltip>
            ))}
        </Stack>
    );
}

export default FlavorBadgesList;
